import React, { createContext, useContext } from 'react'

export type PanelConfig = Record<string, unknown> | undefined

type ConfigContextValue = {
  config: PanelConfig
  setConfig?: (config: PanelConfig) => void
}

const PanelConfigContext = createContext<ConfigContextValue>({ config: undefined })

export const PanelConfigProvider = ({
  config,
  setConfig,
  children,
}: {
  config: PanelConfig
  setConfig?: (config: PanelConfig) => void
  children: React.ReactNode
}) => <PanelConfigContext.Provider value={{ config, setConfig }}>{children}</PanelConfigContext.Provider>

export const usePanelConfig = (): ConfigContextValue => useContext(PanelConfigContext)
